import { BottomCenteredDrawer } from "@jugl-web/ui-components/web/BottomCenteredDrawer";
import Lottie from "react-lottie";
import animationData from "../animations/loading-animation.json";

export const LoadingScreen = () => (
  <BottomCenteredDrawer.Content className="flex flex-col items-center justify-center text-center">
    <Lottie options={{ animationData }} height={70} width={70} />
  </BottomCenteredDrawer.Content>
);
